import { TEspActivityType, TEspMeetingReason } from '../model/types'

/**
 * Dropdown option lists. `key` is the stable persisted value; `value` is the displayed
 * caption (dropdown sources carry data captions, not translation keys — same as the
 * keyInitiativeEditor field sources).
 */
export interface IEspSelectOption<TKey extends string = string> {
  key: TKey
  value: string
}

export const ESP_ACTIVITY_TYPE_OPTIONS: IEspSelectOption<TEspActivityType>[] = [
  { key: 'f2f', value: 'F2F' },
  { key: 'email', value: 'Email' },
  { key: 'virtualMeeting', value: 'Virtual Meeting' },
  { key: 'other', value: 'Others' },
]

export const ESP_MEETING_REASON_OPTIONS: IEspSelectOption<TEspMeetingReason>[] = [
  { key: 'generalCheckIn', value: 'General Check-In' },
  { key: 'requestedByAccount', value: 'Requested by Account' },
  { key: 'accountReview', value: 'Account Review' },
  { key: 'other', value: 'Other' },
]

const getOptionLabel = <TKey extends string>(
  options: IEspSelectOption<TKey>[],
  key: string | null | undefined
): string => options.find((option) => option.key === key)?.value ?? ''

const getOptionKey = <TKey extends string>(
  options: IEspSelectOption<TKey>[],
  label: string | null | undefined
): TKey | null => options.find((option) => option.value === label)?.key ?? null

export const getEspActivityTypeLabel = (key: string | null | undefined): string =>
  getOptionLabel(ESP_ACTIVITY_TYPE_OPTIONS, key)

export const getEspMeetingReasonLabel = (key: string | null | undefined): string =>
  getOptionLabel(ESP_MEETING_REASON_OPTIONS, key)

/**
 * The form dropdowns store the displayed caption (a static Crud + FormDropdown's
 * `keyField` poisons the shared source with a stale filter), so submits map the label
 * back to the stable option key.
 */
export const getEspActivityTypeByLabel = (label: string | null | undefined) =>
  getOptionKey(ESP_ACTIVITY_TYPE_OPTIONS, label)

export const getEspMeetingReasonByLabel = (label: string | null | undefined) =>
  getOptionKey(ESP_MEETING_REASON_OPTIONS, label)
